import { isValidNumber, isValidString } from "./validators";

export const firstLetterCaps = (str: string) => {
  return isValidString(str)
    ? `${str[0].toUpperCase()}${str.substring(1, str.length).toLowerCase()}`
    : "";
};

export const formatAsUsPhoneNo = (input: number) => {
  if (isValidNumber(input)) {
    const cleaned = input.toString().replace(/\D/g, "");
    if (cleaned.length === 10) {
      return `(${cleaned.substring(0, 3)})${cleaned.substring(
        3,
        6
      )}-${cleaned.substring(6)}`;
    } else {
      return input;
    }
  }
  return input;
};
